import React from 'react'
import { useDispatch } from 'react-redux'
import { Icon } from '@iconify/react'
import { Panel } from 'src/components/app-ui'
import URL from 'src/api/url/api'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import ContainerMediaGalery from 'src/container/image-gallery'
import useStyles from './styles'

const mediaUrl = path =>
  !path ? '' : path.startsWith('http') ? path : `${URL.MEDIA}${path}`

const UPLOADS = [
  {
    key: 'logo',
    label: 'Logo',
    cta: 'Upload logo',
    hint: 'SVG or PNG, max 2 MB',
  },
  {
    key: 'favicon',
    label: 'Favicon',
    cta: 'Upload favicon',
    hint: '32×32 PNG or ICO',
  },
]

/**
 * Logo or favicon: picked from (or uploaded to) the media gallery, like the
 * landing page logo. Clicking a filled box picks another one.
 */
const UploadBox = ({ upload, value, onChange }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const openGallery = () =>
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `Media Gallery - ${upload.label}`,
          component: (
            <ContainerMediaGalery
              onOk={items => {
                if (items?.[0]?.url) onChange(items[0].url)
                dispatch(messageBoxHideAction('message-box-1'))
              }}
              setImageURL={() => {}}
            />
          ),
          variant: MessageBoxVariant.DRAGGABLE,
          maxHeight: '640px',
        }),
      ),
    )

  return (
    <div className={classes.field}>
      <div className={classes.uploadLabel}>
        {upload.label}
        {value && (
          <button
            type="button"
            className={classes.linkButton}
            onClick={() => onChange(null)}
          >
            Remove
          </button>
        )}
      </div>
      <button
        type="button"
        className={`${classes.upload} ${value ? classes.uploadFilled : ''}`}
        style={{ width: '100%', fontFamily: 'inherit' }}
        onClick={openGallery}
      >
        {value ? (
          <img
            src={mediaUrl(value)}
            alt={upload.label}
            className={classes.preview}
          />
        ) : (
          <>
            <Icon icon="tabler:upload" width={22} height={22} />
            {upload.cta}
            <span className={classes.uploadHint}>{upload.hint}</span>
          </>
        )}
      </button>
    </div>
  )
}

/** Logo and favicon; each pick or removal is saved right away. */
const LogoCard = ({ branding, onSave }) => {
  const classes = useStyles()
  return (
    <Panel className={classes.card}>
      <div className={classes.cardTitle}>Logo</div>
      <div className={classes.uploads}>
        {UPLOADS.map(upload => (
          <UploadBox
            key={upload.key}
            upload={upload}
            value={branding[upload.key]}
            onChange={value => onSave({ [upload.key]: value })}
          />
        ))}
      </div>
    </Panel>
  )
}

export default LogoCard
